import styled from "@emotion/styled";

export const TabelaContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

